import React from 'react';
import { Input } from 'antd';

const { TextArea } = Input;

export default function CustomTextArea(props) {
	return (
		<>
			<TextArea {...props}  />
		</>
	);
}
